import axios from "./httpClient";

export function getDS82StuckBotApplications(params = {}) {
  return axios.get(`/ds82/applicant/stuck-bot-applications`, { params });
}

// Reprocessing functionality commented out for now
/*
export function reprocessStuckBotApplication(applicantId) {
  return axios.post(
    `/ds82/applicant/stuck-bot-applications/${applicantId}/reprocess`,
  );
}
*/
